import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  accordionItem: {
    display: "flex",
    flexDirection: "column",
    "& + $accordionItem": {
      marginTop: 20
    }
  },
  accordionTitleWrapper: {
    display: "flex",
    alignItems: "center"
  },
  accordionTitle: {},
  accordionSwitcher: {
    marginLeft: 8,
    backgroundColor: "transparent",
    border: "none"
  },
  accordionBody: {}
});
